import React from 'react';
import OrderListTable from "../../../components/OrderListTable";

export const AllOrderPage = () => {
    return (
        <OrderListTable/>
    );
};
